import FadeIn from "./FadeIn";
import { CallCTA, WhatsAppCTA, BookCTA, btnWhite, btnOutlineWhite, btnWhatsApp } from "./CTAs";
import { SITE } from "../data/siteConfig";

const FinalCTA = ({ heading = "Ready to Book Your Test?", text = "Contact our collection center for test availability, appointment information and sample collection enquiries." }) => (
  <section className="bg-[#0B3056] py-16">
    <FadeIn className="mx-auto max-w-4xl px-4 text-center sm:px-6">
      <h2 className="font-heading text-2xl font-extrabold tracking-tight text-white sm:text-3xl">{heading}</h2>
      <p className="mx-auto mt-3 max-w-2xl text-base text-blue-100">{text}</p>
      <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
        <BookCTA className={btnWhite} testId="final-cta-book" />
        <CallCTA label={`Call ${SITE.phone}`} className={btnOutlineWhite} testId="final-cta-call" />
        <WhatsAppCTA className={btnWhatsApp} testId="final-cta-whatsapp" />
      </div>
    </FadeIn>
  </section>
);

export default FinalCTA;
